import { Head, Link } from "@inertiajs/react"

import ReportCard from "@/components/products/reports/ReportCard"
import { useOrgRoutes } from "@/hooks/use-org-routes"
import AppLayout from "@/layouts/app-layout"
import type {
  BreadcrumbItem,
  ReportPageCapabilities,
  ReportSummary,
} from "@/types"

interface Props {
  reports: ReportSummary[]
  capabilities: ReportPageCapabilities
}

export default function ReportsIndex({ reports, capabilities }: Props) {
  const routes = useOrgRoutes()
  const breadcrumbs: BreadcrumbItem[] = [{ title: "Reports", href: "" }]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Reports" />
      <div className="space-y-6 p-4 sm:p-6">
        <div className="space-y-4">
          <h1 className="text-2xl font-semibold">Reports</h1>
          <nav className="flex gap-1 border-b" aria-label="Reports">
            <Link
              href={routes.reportsPath()}
              aria-current="page"
              className="border-primary text-foreground flex h-11 items-center border-b-2 px-3 text-sm font-medium"
            >
              All reports
            </Link>
            {capabilities.can_view_subscriptions_overview && (
              <Link
                href={`${routes.reportsPath()}/subscriptions`}
                className="text-muted-foreground hover:text-foreground flex h-11 items-center border-b-2 border-transparent px-3 text-sm font-medium"
              >
                Subscriptions
              </Link>
            )}
          </nav>
        </div>

        {reports.length === 0 ? (
          <p className="text-muted-foreground">No reports registered.</p>
        ) : (
          <div className="grid gap-3 xl:grid-cols-2">
            {reports.map((report) => (
              <ReportCard key={report.key} report={report} />
            ))}
          </div>
        )}
      </div>
    </AppLayout>
  )
}
